import React, { useContext, useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Tooltip,
  AppBar,
  Toolbar,
} from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { AvatarMenu } from './AvatarMenu';
import Icon from '../../assets/images/Icon.png';
import Logo from '../../assets/images/LogoIcon.png';
import patient_menuItems from './patient_menuItems';
import partner_menuItems from './partner_menuItems';
import integrationDocs_menuItems from './IntegrationDocs_menuItems';
import { PartnerContext } from '../../lib/contexts';
import { ModeContext } from '../../lib/contexts/ModeContext';
import ShareLinkDialog from '../ShareLinkDialog/ShareLinkDialog';
import { ThemeContext } from '../../lib/contexts/ThemeContext';
import MenuIcon from '@mui/icons-material/Menu';

export const MainMenuMobile = ({ openMenu, setIsSidebarOpen }) => {
  const {
    state: { code: partnerCode, userRole, name: partnerName, ...partnerState },
  } = useContext(PartnerContext);
  const { state: modeState } = useContext(ModeContext);
  const [chosenMenuItems, setChosenMenuItems] = useState([]);
  const [showShareLinkDialog, setShowShareLinkDialog] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(() => {
    const savedSubMenuState = localStorage.getItem('submenuOpen');
    return savedSubMenuState !== null ? JSON.parse(savedSubMenuState) : {};
  });
  const isMobile = useMediaQuery('(max-width: 768px)');

  const location = useLocation();
  const navigate = useNavigate();
  const {
    state: { darkMode },
  } = useContext(ThemeContext);

  const [open, setOpen] = useState(() => {
    const savedMenuState = localStorage.getItem('menuOpen');
    return savedMenuState !== null ? JSON.parse(savedMenuState) : openMenu;
  });

  const drawerRef = useRef(null);

  const handleToggleDrawer = () => {
    setOpen(!open);
    setIsSidebarOpen(!open);
  };

  const handleClickOutside = (event) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      setOpen(false);
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    if (isMobile && open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile, open]);

  useEffect(() => {
    if (location.pathname.includes('/docs')) {
      setChosenMenuItems(integrationDocs_menuItems);
    } else {
      setChosenMenuItems(modeState.adminView ? partner_menuItems : patient_menuItems);
    }
  }, [location.pathname, modeState.adminView]);

  useEffect(() => {
    localStorage.setItem('menuOpen', JSON.stringify(open));
  }, [open]);

  return (
    <>
      {isMobile && !open ? (
        <AppBar
          position="fixed"
          sx={{
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: darkMode ? '#333' : '#fff',
            color: darkMode ? '#fff' : '#000',
          }}
        >
          <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <IconButton onClick={handleToggleDrawer}>
              <MenuIcon
                style={{
                  width: '35px',
                  height: '35px',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              />
            </IconButton>
            <AvatarMenu showTopDivider={false} />
          </Toolbar>
        </AppBar>
      ) : (
        <Drawer
          ref={drawerRef}
          variant="permanent"
          open={open}
          sx={{
            width: open ? 260 : 56,
            flexShrink: 0,
            transition: 'width 300ms ease',
            '& .MuiDrawer-paper': {
              width: open ? 260 : 70,
              overflowX: 'hidden',
              transition: 'width 300ms ease',
            },
          }}
        >
          <img
            onClick={handleToggleDrawer}
            src={open ? partnerState.logo_small_url || Logo : Icon}
            alt="Umbrella Index"
            style={{
              cursor: 'pointer',
              width: open ? 150 : 'auto',
              height: open ? 'auto' : 36,
              margin: open ? '20px auto 20px' : '10px auto 10px',
              display: open ? 'block' : 'inherit',
            }}
          />
          <Divider />
          <List
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: '100%',
              maxHeight: modeState.adminView ? (open ? 450 : '40%') : open ? 250 : '20%',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            {chosenMenuItems
              .filter((item) => !item.disabled)
              .map((item, index, array) => (
                <React.Fragment key={item.slug || index}>
                  <Tooltip
                    title={item.tooltip || item.text}
                    placement="right"
                    arrow
                  >
                    <ListItem
                      button
                      component={item.path && !item.url ? RouterLink : 'a'}
                      to={item.path && !item.url ? item.path : null}
                      href={item.url ? item.url : `#${item.slug}`}
                      onClick={(e) => {
                        if (item.url) {
                          e.preventDefault();
                          window.open(item.url, '_blank');
                        } else if (item.slug === 'share-link') {
                          e.preventDefault();
                          setShowShareLinkDialog(true);
                        } else if (item.name === 'Dashboard') {
                          navigate('/dashboard');
                        } else if (!item.path && item.children) {
                          e.stopPropagation();
                          handleClick(item.slug);
                        }
                      }}
                    >
                      <ListItemIcon sx={{ color: darkMode ? 'white' : 'black' }}>{item.icon}</ListItemIcon>
                      {open && <ListItemText primary={item.text} />}
                    </ListItem>
                  </Tooltip>
                  {index < array.length - 1 && <Divider />}
                </React.Fragment>
              ))}
          </List>
        </Drawer>
      )}

      {showShareLinkDialog && <ShareLinkDialog handleClose={() => setShowShareLinkDialog(false)} />}
    </>
  );
};
